angular
	.module 'App.Module.PromotionCampaign', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY, SEARCH_CONFIGURATION) ->
		$stateProvider
			.state 'promotion',
				url: '/promotion',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					'entity_search@promotion':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'PromotionCampaignSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.Promotions'
					searchParams:
						advanced:
							configuration: SEARCH_CONFIGURATION.promotion
						labelTemplate: '@app/promotion-campaign/promotion-campaign.search-label.view.html'
						repositoryName: 'PromotionRepository'
						title: 'wbo.promotion.search.title'
						filterEnabled: ->
							return @ConfigurationService.get 'Backoffice.PromotionManagement.EnableSearch'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					customerGroups: (CustomerGroupRepository) ->
						return CustomerGroupRepository.getEntities()
					productCategories: (ProductCategoryRepository) ->
						return ProductCategoryRepository.getEntities()
					promotionTypeIsCampaign: -> true
					productFilters: (ProductFilterRepository) ->
						return ProductFilterRepository.getEntities()

			.state 'promotion.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					#NOTE: A promotion is loaded in 3 steps. Firstly only details and the benefit is loaded
					#      afterwards the benefit products and the eligible sets. This is done to reduce SQL join hell
					PromotionCampaignModel: ($stateParams, PromotionCampaignService, PromotionRepository, ConfigurationService) ->
						if _.isEmpty($stateParams.id)
							return PromotionCampaignService.injectPromotion(null)

						query = PromotionCampaignService.getQuery()
						query.with 'shops'
						query.with 'qualification'
						query.with 'benefit'
						query.with 'recurrences'

						if ConfigurationService.isEnabled 'Backoffice.ShopManagement.Shops.EnableShopGroups'
							query.with 'shop_groups'

						return PromotionRepository
							.getEntity($stateParams.id, query)
							.then (response) =>
								return PromotionCampaignService.injectPromotion(response)

					_products: ($stateParams, PromotionCampaignService, PromotionCampaignModel) ->
						if _.isEmpty($stateParams.id)
							return

						PromotionCampaignService
							.loadPromotionBenefitProductsByCampaignId PromotionCampaignModel.data().id
							.then (products) =>
								PromotionCampaignModel.setBenefitProducts(_.reject(products, (item) -> item.products == null))

					_categories: ($stateParams, PromotionCampaignService, PromotionCampaignModel) ->
						if _.isEmpty($stateParams.id)
							return

						PromotionCampaignService
							.loadPromotionBenefitProductCategoriesByCampaignId PromotionCampaignModel.data().id
							.then (categories) =>
								PromotionCampaignModel.setBenefitProductCategories(categories)

					_sets: ($stateParams, PromotionCampaignService, PromotionCampaignModel) ->
						if _.isEmpty($stateParams.id)
							return

						PromotionCampaignService
							.loadPromotionEligibleSetsByCampaignId PromotionCampaignModel.data().id
							.then (sets) =>
								PromotionCampaignModel.setEligibleSets(sets)

			.state 'promotion.edit.details',
				url: '/edit',
				views:
					entity_sub_view:
						controller: 'PromotionCampaignController'
						controllerAs: 'vm'
						templateUrl: '@app/promotion-campaign/promotion-campaign.view.html'
